<template lang="">
  <div class="bbs_write">
    <div class="bbs_info">
      <div class="required">* 필수 입력사항</div>
    </div>
    <table class="bbs_tbl">
      <colgroup>
        <col style="width:140px">
        <col style="width:auto">
      </colgroup>
      <tbody>
        <tr>
          <th scope="row"><span class="txt_required">* 관리자 PRID</span></th>
          <td>
            <div class="item">
              <input type="text" class="i_txt lineless" placeholder="아이디를 입력or검색해주세요" required style="width:280px" v-model="username" :disabled="creating">
              <button type="button" class="bt_base primary" style="width:106px;" @click="searchUsername">아이디 검색</button>
            </div>
          </td>
        </tr>
        <tr>
          <th scope="row">관리자 설명</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="설명을 작성해주세요" v-model="description">
            </div>
          </td>
        </tr>
        <tr v-if="newAccount">
          <th scope="row">관리자 비밀번호</th>
          <td>
            <div class="item">
              <input type="password" class="i_txt type_full lineless" placeholder="비밀번호를 입력해주세요" v-model="pwd">
            </div>
          </td>
        </tr>
        <tr v-if="newAccount">
          <th scope="row">비밀번호 확인</th>
          <td>
            <div class="item">
              <input type="password" class="i_txt type_full lineless" placeholder="비밀번호를 확인해 주세요" v-model="pwdCheck">
            </div>
          </td>
        </tr>
        <tr v-if="newAccount">
          <th scope="row">관리자 성함</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="관리자의 이름을 입력해 주세요" v-model="name">
            </div>
          </td>
        </tr>
        <tr v-if="newAccount">
          <th scope="row">관리자 부서</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="관리자의 부서를 입력해 주세요" v-model="division">
            </div>
          </td>
        </tr>
        <tr v-if="newAccount">
          <th scope="row">관리자 이메일</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="관리자의 이메일을 입력해 주세요" v-model="email">
            </div>
          </td>
        </tr>
        <tr v-if="newAccount">
          <th scope="row">관리자 연락처</th>
          <td>
            <div class="item">
              <input type="text" class="i_txt type_full lineless" placeholder="관리자의 연락처를 입력해 주세요" v-model="phoneNum">
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="bbs_controller">
    <div class="rgt_area">
      <button type="button" class="bt_base primary large_h" @click="createAdminAccount">저장</button>
      <button type="button" class="bt_base gray large_h" @click="toList">목록</button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapState } from 'vuex';

const adminAccountModule = 'adminAccountModule'

export default {
  data () {
    return {
      username: '',
      description: '',
      pwd: '',
      pwdCheck: '',
      name: '',
      division: '',
      email: '',
      phoneNum: '',
      newAccount: false,
      creating: false,
      roleType: 'ADMIN'
    }
  },
  
  methods: {
    toList () {
      this.$router.push({name: 'AdminAccountManageListPage'})
    },

    ...mapActions(adminAccountModule, [
      'searchAdminUsername',
      'requestCreateAccount'
    ]),

    async searchUsername() {
      const username = this.username
      const searchResult = await this.searchAdminUsername(username)
      switch(searchResult) {
        case 'noAccount' : 
          if (confirm("계정이 존재 하지 않습니다, 새로 생성하시겠습니까?")) this.newAccount = true
          this.creating = true
          break;

        case 'existing' : 
          this.newAccount = false
          this.description = this.adminAccount.description
          break;

        case 'normalAccount' : 
          alert("검색한 계정은 일반회원 계정입니다.")
      }
    },

    async createAdminAccount() {
      if (this.pwd !== this.pwdCheck) alert("비밀번호가 일치하지 않습니다")
      else {
        const {username, description, pwd, name, division, email, phoneNum, roleType} = this
        if (await this.requestCreateAccount({username, description, pwd, name, division, email, phoneNum, roleType})) {
          alert("계정이 생성 됐습니다")
          this.$router.push({name: 'AdminAccountManageListPage'})
        }
      }
    }
  },

  computed: {
    ...mapState(adminAccountModule, [
      'adminAccount'
    ])
  }
}
</script>
<style lang="">
    
</style>